module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-UltraLight.ddf93cd1.ttf";